import { DynamicFieldProps, FieldRenderer } from './dynamic-field.types';
import { DynamicDateField } from './fields/dynamic-date-field';
import { DynamicTextInputField } from './fields/dynamic-text-input-field';
import { DynamicNumberField } from './fields/dynamic-number-filed';
import { FormField } from '../../dynamic-form.types';

const fieldRenderers: Record<FormField['type'], FieldRenderer> = {
  date: DynamicDateField,
  'text-input': DynamicTextInputField,
  number: DynamicNumberField,
};

export const DynamicField = ({ field, control }: DynamicFieldProps) => {
  const label = field.copy;

  const renderer = fieldRenderers[field.type];

  if (!renderer) {
    throw new Error(`Unsupported field type: ${field.type}`);
  }

  return renderer(field, control, label);
};
